<template lang="pug">
.section
  .section-header
    .section-header-back(v-if="!isOperator")
      a.btn.btn-sm.btn-icon(href="javascript:void(0)" @click="redirect()")
        i.fas.fa-arrow-left
    h1 {{ $t("ui.settings") }}
    .section-header-breadcrumb
      .breadcrumb-item
        router-link(to="/account/operator") {{ $tc("ui.operators", 2) }}
      .breadcrumb-item.active
        router-link(to="/account/settings") {{ $t('ui.settings') }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-body
            .row
              .col-12.mb-3.d-flex.align-items-center
                .section-title.m-1.d-flex.w-100
                  div {{ operatorID }}    
                  template(v-if="!isOperator && isReady && cpiEnable && showActionButton('cpi')")
                    div.ml-auto(v-if="!hasCpi")
                      .dropdown(v-if="['MYR'].includes(getCurrencyCode) || isUat == 'true'")
                        .ml-2.btn.btn-info(:title='$t("ui.cpi_enrol")' @click="cpiEnrol()")
                          span {{ $t("ui.cpi_enrol") }}
                  //- .ml-2.btn.btn-info(v-if="!isOperator && showActionButton('adjustbalanceop')" :title='$t("ui.cash_balance")') 
                  //-   span(@click="operatorWalletAdjust()") {{ currencyCode + " " + $n(cashBalance, 'currency') }}
                  //-   .ml-2.btn.btn-ssm.btn-dark.fa.fa-list(:title='$t("ui.audit_log")' @click="operatorAuditLog('wallet')")                            
              .col-12 
                ul#operatortab.nav.nav-tabs(role='tablist')
                  li.nav-item(v-if="showActionButton('memberlist')" @click="refresh('memberlist')")
                    a#memberlist-tab.nav-link(:class="{ active: firstVisibleTab === 'memberlist' }" data-toggle='tab' href='#memberlist-content' role='tab' aria-controls='memberlist' aria-selected='false') {{ $t("ui.members") }}
                  li.nav-item(v-if="showActionButton('promotion') || showActionButton('promomember') || showActionButton('promosignup')" @click="refresh('promotion')")
                    a#promotioncontainer-tab.nav-link(:class="{ active: firstVisibleTab === 'promotion' }" data-toggle='tab' href='#promotioncontainer-content' role='tab' aria-controls='promotioncontainer' aria-selected='false') {{ $t("ui.promotion") }}
                  li.nav-item(v-if="showActionButton('vip')" @click="refresh('vip')")
                    a#vip-tab.nav-link(:class="{ active: firstVisibleTab === 'vip' }" data-toggle='tab' href='#vip-content' role='tab' aria-controls='vip' aria-selected='false') {{ $t("ui.vip") }}
                  li.nav-item(v-if="showActionButton('paymentoption')" @click="refresh('paymentoption')")
                    a#paymentoption-tab.nav-link(:class="{ active: firstVisibleTab === 'paymentoption' }" data-toggle='tab' href='#paymentoption-content' role='tab' aria-controls='paymentoption' aria-selected='false') {{ $t("ui.payment_option") }}
                  li.nav-item(v-if="showActionButton('campaign')" @click="refresh('campaign')")
                    a#campaign-tab.nav-link(:class="{ active: firstVisibleTab === 'campaign' }" data-toggle='tab' href='#campaign-content' role='tab' aria-controls='campaign' aria-selected='false') {{ $t("ui.mbcampaign") }}
                  li.nav-item(v-if="showActionButton('operatorsetting')" @click="refresh('operatorsetting')")
                    a#operatorsetting-tab.nav-link(:class="{ active: firstVisibleTab === 'operatorsetting' }" data-toggle='tab' href='#operatorsetting-content' role='tab' aria-controls='operatorsetting' aria-selected='false') {{ $t("ui.mbsetting") }}
                  li.nav-item(v-if="showActionButton('turnovertier')" @click="refresh('turnovertier')")
                    a#turnovertier-tab.nav-link(:class="{ active: firstVisibleTab === 'turnovertier' }" data-toggle='tab' href='#turnovertier-content' role='tab' aria-controls='turnovertier' aria-selected='false') {{ $t("ui.turnover_tier") }}
                  li.nav-item(v-if="showActionButton('cms') || showActionButton('aiassistant')" @click="refresh('cms')")
                    a#cms-tab.nav-link(:class="{ active: firstVisibleTab === 'cms' }" data-toggle='tab' href='#cms-content' role='tab' aria-controls='cms' aria-selected='false') {{ $t("ui.cms") }}
                  li.nav-item(v-if="showActionButton('rescuefund')" @click="refresh('rescuefund')")
                    a#rescuefund-tab.nav-link(:class="{ active: firstVisibleTab === 'rescuefund' }" data-toggle='tab' href='#rescuefund-content' role='tab' aria-controls='rescuefund' aria-selected='false') {{ $t("ui.rescue_fund") }}
                  li.nav-item(v-if="showActionButton('gamenameexclude')" @click="refresh('gamenameexclude')")
                    a#gamenameexclude-tab.nav-link(:class="{ active: firstVisibleTab === 'gamenameexclude' }" data-toggle='tab' href='#gamenameexclude-content' role='tab' aria-controls='gamenameexclude' aria-selected='false') {{ $t("ui.game_name_exclude") }}
                  li.nav-item(v-if="showActionButton('bankmember')" @click="refresh('bankmember')")
                    a#bankmember-tab.nav-link(:class="{ active: firstVisibleTab === 'bankmember' }" data-toggle='tab' href='#bankmember-content' role='tab' aria-controls='bankmember' aria-selected='false') {{ $t("ui.bank_member") }}
                  li.nav-item(v-if="showActionButton('bank') || showActionButton('bankstatement') || showActionButton('bankstatementdaily')" @click="refresh('bank')")
                    a#bankcontainer-tab.nav-link(:class="{ active: firstVisibleTab === 'bank' }" data-toggle='tab' href='#bankcontainer-content' role='tab' aria-controls='bankcontainer' aria-selected='false') {{ $t("ui.bank") }}
                  li.nav-item(v-if="showActionButton('memberlabel')" @click="refresh('memberlabel')")
                    a#memberlabel-tab.nav-link(:class="{ active: firstVisibleTab === 'memberlabel' }" data-toggle='tab' href='#memberlabel-content' role='tab' aria-controls='memberlabel' aria-selected='false') {{ $t("ui.member_label") }}
                  li.nav-item(v-if="showActionButton('ads')" @click="refresh('ads')")
                    a#ads-tab.nav-link(:class="{ active: firstVisibleTab === 'ads' }" data-toggle='tab' href='#acs-content' role='tab' aria-controls='ads' aria-selected='false') {{ $t("ui.advertisement") }}
                  li.nav-item.exchangerate-item(v-if="showActionButton('exchangerate')" @click="refresh('exchangerate')")
                    a#exchangerate-tab.nav-link(:class="{ active: firstVisibleTab === 'exchangerate' }" data-toggle='tab' href='#exchangerate-content' role='tab' aria-controls='exchangerate' aria-selected='false') {{ $t("ui.exchange_rate") }}
                  li.nav-item(v-if="showActionButton('gamifyoperator') || showActionButton('rewardrain')" @click="refresh('gamifyoperator')")
                    a#rewardcontainer-tab.nav-link(:class="{ active: firstVisibleTab === 'gamifyoperator' }" data-toggle='tab' href='#rewardcontainer-content' role='tab' aria-controls='rewardcontainer' aria-selected='false') {{ $t("ui.reward") }}
                  template(v-if="!isOperator")
                    li.nav-item.dashboardop-item(v-if="showActionButton('dashboardop')" @click="refresh('dashboardop')")
                      a#dashboardop-tab.nav-link(:class="{ active: firstVisibleTab === 'dashboardop' }" data-toggle='tab' href='#dashboardop-content' role='tab' aria-controls='dashboardop' aria-selected='false') {{ $t("ui.dashboard") }}
                    template(v-if="cpiEnable")
                      li.nav-item(v-if="showActionButton('cpi') && hasCpi" @click="refresh('cpi')")
                        a#cpicontainer-tab.nav-link(:class="{ active: firstVisibleTab === 'cpi' }" data-toggle='tab' href='#cpicontainer-content' role='tab' aria-controls='cpicontainer' aria-selected='false') {{ $t("ui.cpi") }}
                  li.nav-item.leaderboard-item(v-if="showActionButton('leaderboard')" @click="refresh('leaderboard')")
                    a#leaderboard-tab.nav-link(:class="{ active: firstVisibleTab === 'leaderboard' }" data-toggle='tab' href='#leaderboard-content' role='tab' aria-controls='leaderboard' aria-selected='false') {{ $t("ui.leaderboard") }}
                  li.nav-item.mission-item(v-if="showActionButton('mission')" @click="refresh('mission')")
                    a#mission-tab.nav-link(:class="{ active: firstVisibleTab === 'mission' }" data-toggle='tab' href='#mission-content' role='tab' aria-controls='mission' aria-selected='false') {{ $t("ui.mission") }}
                  //- li.nav-item.linkageop-item(v-if="showActionButton('linkageop')" @click="refresh('linkageop')")
                  //-   a#linkageop-tab.nav-link(:class="{ active: firstVisibleTab === 'linkageop' }" data-toggle='tab' href='#linkageop-content' role='tab' aria-controls='linkageop' aria-selected='false') {{ $t("ui.linkage") }}

                #operatortabcontent.tab-content.tab-bordered
                  #vip-content.tab-pane.fade(v-if="showActionButton('vip')" :class="{ active: firstVisibleTab === 'vip', show: firstVisibleTab === 'vip' }" role='tabpanel' aria-labelledby='vip-tab')
                    vipTab(ref="vipTab")
                  #paymentoption-content.tab-pane.fade(v-if="showActionButton('paymentoption')" :class="{ active: firstVisibleTab === 'paymentoption', show: firstVisibleTab === 'paymentoption' }" role='tabpanel' aria-labelledby='paymentoption-tab')
                    paymentOptionTab(ref="paymentOptionTab")
                  #campaign-content.tab-pane.fade(v-if="showActionButton('campaign')" :class="{ active: firstVisibleTab === 'campaign', show: firstVisibleTab === 'campaign' }" role='tabpanel' aria-labelledby='campaign-tab')
                    campaignTab(ref="campaignTab")
                  #promotioncontainer-content.tab-pane.fade(v-if="showActionButton('promotion') || showActionButton('promomember') || showActionButton('promosignup')" :class="{ active: firstVisibleTab === 'promotion', show: firstVisibleTab === 'promotion' }" role='tabpanel' aria-labelledby='promotioncontainer-tab')
                    promotionContainerTab(ref="promotionContainerTab")
                  #memberlist-content.tab-pane.fade(v-if="showActionButton('memberlist')" :class="{ active: firstVisibleTab === 'memberlist', show: firstVisibleTab === 'memberlist' }" role='tabpanel' aria-labelledby='memberlist-tab')
                    memberTab#memberTab(ref="memberTab")
                  #operatorsetting-content.tab-pane.fade(v-if="showActionButton('operatorsetting')" :class="{ active: firstVisibleTab === 'operatorsetting', show: firstVisibleTab === 'operatorsetting' }" role='tabpanel' aria-labelledby='operatorsetting-tab')
                    operatorSettingTab(ref="operatorSettingTab")
                  #turnovertier-content.tab-pane.fade(v-if="showActionButton('turnovertier')" :class="{ active: firstVisibleTab === 'turnovertier', show: firstVisibleTab === 'turnovertier' }" role='tabpanel' aria-labelledby='turnovertier-tab')
                    turnovertierTab(ref="turnovertierTab")
                  #cms-content.tab-pane.fade(v-if="showActionButton('cms') || showActionButton('aiassistant')" :class="{ active: firstVisibleTab === 'cms', show: firstVisibleTab === 'cms' }" role='tabpanel' aria-labelledby='cms-tab')
                    cmsTab(ref="cmsTab")
                  #rescuefund-content.tab-pane.fade(v-if="showActionButton('rescuefund')" :class="{ active: firstVisibleTab === 'rescuefund', show: firstVisibleTab === 'rescuefund' }" role='tabpanel' aria-labelledby='rescuefund-tab')
                    rescueFundTab(ref="rescueFundTab")
                  #gamenameexclude-content.tab-pane.fade(v-if="showActionButton('gamenameexclude')" :class="{ active: firstVisibleTab === 'gamenameexclude', show: firstVisibleTab === 'gamenameexclude' }" role='tabpanel' aria-labelledby='gamenameexclude-tab')
                    gameNameExcludeTab(ref="gameNameExcludeTab")
                  #bankmember-content.tab-pane.fade(v-if="showActionButton('bankmember')" :class="{ active: firstVisibleTab === 'bankmember', show: firstVisibleTab === 'bankmember' }" role='tabpanel' aria-labelledby='bankmember-tab')
                    bankMemberTab(ref="bankMemberTab")
                  #bankcontainer-content.tab-pane.fade(v-if="showActionButton('bank') || showActionButton('bankstatement') || showActionButton('bankstatementdaily')" :class="{ active: firstVisibleTab === 'bank', show: firstVisibleTab === 'bank' }" role='tabpanel' aria-labelledby='bank-tab')
                    bankContainerTab(ref="bankContainerTab")
                  #memberlabel-content.tab-pane.fade(v-if="showActionButton('memberlabel')" :class="{ active: firstVisibleTab === 'memberlabel', show: firstVisibleTab === 'memberlabel' }" role='tabpanel' aria-labelledby='memberlabel-tab')
                    memberLabelTab(ref="memberLabelTab")
                  #acs-content.tab-pane.fade(v-if="showActionButton('ads')" :class="{ active: firstVisibleTab === 'ads', show: firstVisibleTab === 'ads' }" role='tabpanel' aria-labelledby='ads-tab')
                    advertisementTab(ref="advertisementTab")
                  #exchangerate-content.tab-pane.fade(v-if="showActionButton('exchangerate')" :class="{ active: firstVisibleTab === 'exchangerate', show: firstVisibleTab === 'exchangerate' }" role='tabpanel' aria-labelledby='exchangerate-tab')
                    exchangeRateTab(ref="exchangeRateTab")
                  #rewardcontainer-content.tab-pane.fade(v-if="showActionButton('gamifyoperator') || showActionButton('rewardrain')" :class="{ active: firstVisibleTab === 'gamifyoperator', show: firstVisibleTab === 'gamifyoperator' }" role='tabpanel' aria-labelledby='gamifyoperator-tab')
                    rewardContainerTab(ref="rewardContainerTab")
                  template(v-if="!isOperator")
                    #dashboardop-content.tab-pane.fade(v-if="showActionButton('dashboardop')" :class="{ active: firstVisibleTab === 'dashboardop', show: firstVisibleTab === 'dashboardop' }" role='tabpanel' aria-labelledby='dashboardop-tab')
                      dashboardTab(ref="dashboardTab")
                    template(v-if="cpiEnable")
                      #cpicontainer-content.tab-pane.fade(v-if="showActionButton('cpi') && hasCpi" :class="{ active: firstVisibleTab === 'cpi', show: firstVisibleTab === 'cpi' }" role='tabpanel' aria-labelledby='cpi-tab')
                        cpiContainerTab(ref="cpiContainerTab")
                  #leaderboard-content.tab-pane.fade(v-if="showActionButton('leaderboard')" :class="{ active: firstVisibleTab === 'leaderboard', show: firstVisibleTab === 'leaderboard' }" role='tabpanel' aria-labelledby='leaderboard-tab')
                    leaderboardTab(ref="leaderboardTab")
                  #mission-content.tab-pane.fade(v-if="showActionButton('mission')" :class="{ active: firstVisibleTab === 'mission', show: firstVisibleTab === 'mission' }" role='tabpanel' aria-labelledby='mission-tab')
                    missionTab(ref="missionTab")
                  //- #linkageop-content.tab-pane.fade(v-if="showActionButton('linkageop')" :class="{ active: firstVisibleTab === 'linkageop', show: firstVisibleTab === 'linkageop' }" role='tabpanel' aria-labelledby='linkageop-tab')
                  //-   linkageOperatorTab(ref="linkageOperatorTab")

    operatorwalletadjust(ref="operatorwalletadjust" @clicked="afterAdjustOperator" @failed="handleFailed")
    operatorauditlog(ref="operatorauditlog" :mode="selectedLog")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import ValidateResult from "@/library/ValidateResult";

import vipTab from "@/components/operatorTab/vipTab.vue";
import paymentOptionTab from "@/components/operatorTab/paymentOptionTab.vue";
import campaignTab from "@/components/operatorTab/campaignTab.vue";
import promotionContainerTab from "@/components/operatorTab/promotionContainerTab.vue";
import memberTab from "@/components/operatorTab/memberTab.vue";
import operatorSettingTab from "@/components/operatorTab/operatorSettingTab.vue";
import providerRtpTab from "@/components/operatorTab/providerRtpTab.vue";
import turnovertierTab from "@/components/operatorTab/turnovertierTab.vue";
import cmsTab from "@/components/operatorTab/cmsTab.vue";
import rescueFundTab from "@/components/operatorTab/rescueFundTab.vue";
import gameNameExcludeTab from "@/components/operatorTab/gameNameExcludeTab.vue";
import bankMemberTab from "@/components/operatorTab/bankMemberTab.vue";
import bankContainerTab from "@/components/operatorTab/bankContainerTab.vue";
import memberLabelTab from "@/components/operatorTab/memberLabelTab.vue";
import reviewTab from "@/components/operatorTab/reviewTab.vue";
import advertisementTab from "@/components/operatorTab/advertisementTab.vue";
import exchangeRateTab from "@/components/operatorTab/exchangeRateTab.vue";
import dashboardTab from "@/components/operatorTab/dashboardTab.vue";
import operatorwalletadjust from "@/components/operator/operatorWalletAdjust.vue";
import operatorauditlog from "@/components/operator/operatorAuditLog.vue";
import rewardContainerTab from "@/components/operatorTab/rewardContainerTab.vue";
import cpiMemberListTab from "@/components/operatorTab/cpiMemberListTab.vue";
import cpiCustomListTab from "@/components/operatorTab/cpiCustomListTab.vue";
import cpiOperatorPhoneListTab from "@/components/operatorTab/cpiOperatorPhoneListTab.vue";
import leaderboardTab from "@/components/operatorTab/leaderboardTab.vue";
import cpiContainerTab from "@/components/operatorTab/cpiContainerTab.vue";
import linkageOperatorTab from "@/components/operatorTab/linkageOperatorTab.vue";
import missionTab from "@/components/operatorTab/missionTab.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ValidateResult,
    vipTab,
    paymentOptionTab,
    campaignTab,
    promotionContainerTab,
    memberTab,
    operatorSettingTab,
    providerRtpTab,
    turnovertierTab,
    cmsTab,
    rescueFundTab,
    gameNameExcludeTab,
    bankMemberTab,
    bankContainerTab,
    memberLabelTab,
    reviewTab,
    advertisementTab,
    exchangeRateTab,
    dashboardTab,
    operatorwalletadjust,
    operatorauditlog,
    rewardContainerTab,
    cpiMemberListTab,
    cpiCustomListTab,
    cpiOperatorPhoneListTab,
    leaderboardTab,
    cpiContainerTab,
    linkageOperatorTab,
    missionTab
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    currentPage: 1,
    totalRow: 0,
    sortKey: "account_id",
    sortType: "asc",
    cashBalance: 0,
    selectedLog: "wallet",
    timerBalance: null,
    refreshOpBalanceTime: 30,
    tabs: ['memberlist','promotion','vip','paymentoption','campaign','operatorsetting','turnovertier','cms','rescuefund','gamenameexclude','bankmember','bank','memberlabel','ads','exchangerate','gamifyoperator','dashboardop','cpi','leaderboard','mission'],
    firstVisibleTab: null,
    redirectFromSystemBalance: false,
    firstVisibleSubTab: null,
    hasCpi: false,
    isUat: config.isUat,
    isReady: false
  }),
  computed: {
    // currencyCode() {
    //   return "USDT";
    // },
    baseCurrency() {
      return config.currency;
    },
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    loginId() {
      return this.$store.getters.loginId;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
    isSubAccount() {
      if (this.getAuthorityRole == 'OWNER_PRI' || this.getAuthorityRole == 'OWNER_SEC') {
          return false;
      } else {
          return true;
      }
    },
    cpiEnable() {
      return config.cpiEnable == "1";
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  watch: {
    tabs: {
      handler() {
        this.updateFirstVisibleTab();
      },
      deep: true,
    },
  },
  mounted: function() {
    if(this.$store.getters.sessionToken) {
      this.updateFirstVisibleTab();
      if(this.cpiEnable)
        this.cpiDetails()
    }
  },
  destroyed: function() {
    if (this.timerBalance) {
      clearTimeout(this.timerBalance);
    }
  },
  methods: {
    cpiEnrol: function() {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.cpi_enrol_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmCpiEnrol();
          }
        });
    },
    confirmCpiEnrol: function() {
      let url = config.cpiEnrolUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.operatorID
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.cpi_enrol"), this.$t("message.success"), "success");
                this.$store.dispatch("user/setCpiDetails", true);
                this.hasCpi = true;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    cpiDetails: function() {
      this.hasCpi = false;

      let url = config.cpiDetailsUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          this.isReady = true
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                var dt = response.data.dt
                if(dt != null && dt.length > 0) {
                  this.hasCpi = true
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          this.isReady = true
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    updateFirstVisibleTab() {
      // // Find the first tab that should be visible
      // this.firstVisibleTab = this.tabs.find((tab) => this.showActionButton(tab)) || null;
      if (this.$route.query.targetTab && this.tabs.includes(this.$route.query.targetTab)) {
        this.firstVisibleTab = this.$route.query.targetTab;

        if (this.$route.query.subTab) { this.firstVisibleSubTab = this.$route.query.subTab; }
      }
      else {
        // Find the first tab that should be visible
        this.firstVisibleTab = this.tabs.find((tab) => this.showActionButton(tab)) || null;
      }

      // Trigger your desired action here, such as initializing the first tab
      if (this.firstVisibleTab) {
        this.refresh(this.firstVisibleTab);
      }
    },
    redirect(mode) {
      this.$store.dispatch("user/setSelectedMemberID", null);
      if(mode) {
        //redirect to member tab and query sort_balance = true
        // var vm = this;
        this.redirectFromSystemBalance = mode
        $(document).ready(function(){
          if(document.getElementById('memberlist-tab') != null) {
            document.getElementById('memberlist-tab').click()
            // if(!document.getElementById('memberlist-tab').classList.contains('active')){
            //   document.getElementById('memberlist-tab').click()
            // }
            // vm.$nextTick(() => {
            //   if(vm.$refs.memberTab) {
            //     vm.$refs.memberTab.refreshSortBalance();
            //   }
            // });
          }
        });

      } else {
        this.$router.push("/account/operator");
      }
    },
    showActionButton(action) {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles =  roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes(action))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        return true;
      }
    },
    refresh: function(tab) {
      if(tab != 'cpi') {
        if(this.$refs.cpiContainerTab) {
          this.$refs.cpiContainerTab.destroyTimer();
        }
      }
      switch(tab) {
        case 'vip':
          if(this.$refs.vipTab) {
            this.$refs.vipTab.refresh();
          }
          break
        case 'paymentoption':
          if(this.$refs.paymentOptionTab) {
            this.$refs.paymentOptionTab.refresh();
          }
          break
        // case 'paymentprovider':
        //   if(this.$refs.paymentProviderTab) {
        //     this.$refs.paymentProviderTab.refresh();
        //   }
        //   break
        case 'campaign':
          if(this.$refs.campaignTab) {
            this.$refs.campaignTab.refresh();
          }
          break
        case 'promotion':
          if(this.$refs.promotionContainerTab) {
            var firstTab = (this.firstVisibleSubTab && ['promotion','promomember','promosignup'].includes(this.firstVisibleSubTab)) ? this.firstVisibleSubTab : 'promotion';
            // this.$refs.promotionContainerTab.refresh('promotion');
            this.$refs.promotionContainerTab.refresh(firstTab);
          }
          break
        case 'memberlist':
          if(this.$refs.memberTab) {
            if(this.redirectFromSystemBalance) {
              this.$refs.memberTab.refreshSortBalance();
            } else {
              this.$refs.memberTab.refresh();
            }
          }
          break
        case 'operatorsetting':
          if(this.$refs.operatorSettingTab) {
            this.$refs.operatorSettingTab.refresh();
          }
          break
        case 'providerrtp':
          if(this.$refs.providerRtpTab) {
            this.$refs.providerRtpTab.refresh();
          }
          break
        case 'turnovertier':
          if(this.$refs.turnovertierTab) {
            this.$refs.turnovertierTab.refresh();
          }
          break
        case 'socialaccount':
          if(this.$refs.socialaccount) {
            this.$refs.socialaccount.refresh();
          }
          break
        case 'cms':
          if(this.$refs.cmsTab) {
            var firstTab = (this.firstVisibleSubTab && ['announcementbanner','aiassistant'].includes(this.firstVisibleSubTab)) ? this.firstVisibleSubTab : 'announcementbanner';
            this.$refs.cmsTab.refresh(firstTab);
          }
          break
        case 'rescuefund':
          if(this.$refs.rescueFundTab) {
            this.$refs.rescueFundTab.refresh();
          }
          break
        case 'gamenameexclude':
          if(this.$refs.gameNameExcludeTab) {
            this.$refs.gameNameExcludeTab.refresh();
          }
          break
        case 'bankmember':
          if(this.$refs.bankMemberTab) {
            this.$refs.bankMemberTab.refresh();
          }
          break
        case 'bank':
          if(this.$refs.bankContainerTab) {
            this.$refs.bankContainerTab.refresh('bank');
          }
          break
        case 'memberlabel':
          if(this.$refs.memberLabelTab) {
            this.$refs.memberLabelTab.refresh();
          }
          break
        case 'review':
          if(this.$refs.reviewTab) {
            this.$refs.reviewTab.refresh('reviewlist');
          }
          break
        // case 'gameresult':
        //   if(this.$refs.gameResultTab) {
        //     this.$refs.gameResultTab.refresh('gameresultslots');
        //   }
        //   break
        case 'ads':
          if(this.$refs.advertisementTab) {
            this.$refs.advertisementTab.refresh();
          }
          break
        case 'dashboardop':
          if(this.$refs.dashboardTab) {
            this.$refs.dashboardTab.refresh('dashboardop');
          }
          break
        case 'exchangerate':
          if(this.$refs.exchangeRateTab) {
            this.$refs.exchangeRateTab.refresh();
          }
          break
        case 'gamifyoperator':
          if(this.$refs.rewardContainerTab) {
            var firstTab = (this.firstVisibleSubTab && ['gamifyoperator','rewardrain'].includes(this.firstVisibleSubTab)) ? this.firstVisibleSubTab : 'gamifyoperator';
            this.$refs.rewardContainerTab.refresh(firstTab);
          }
          break
          break
        case 'cpi' :
          if(this.$refs.cpiContainerTab) {
            this.$refs.cpiContainerTab.refresh('cpi');
          }
          break
        case 'leaderboard':
          if(this.$refs.leaderboardTab) {
            this.$refs.leaderboardTab.refresh();
          }
          break
        case 'mission':
          if(this.$refs.missionTab) {
            this.$refs.missionTab.refresh();
          }
          break
        case 'linkageop':
          if(this.$refs.linkageOperatorTab) {
            this.$refs.linkageOperatorTab.refresh();
          }
          break
      }
    },
    operatorWalletAdjust() {
      this.$refs.operatorwalletadjust.$refs.operatorWalletAdjust.show();
    },
    operatorAuditLog(mode) {
      this.selectedLog = mode;
      this.$refs.operatorauditlog.$refs.operatorAuditLog.show();
    },
    afterAdjustOperator: function() {
      // this.getOperatorBalance();
      this.$helpers.showDialog(this.$t("ui.combine.operator_wallet_adjust"), this.$t("message.success"), "success");
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>